import React from "react";
import { Modal, Button, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { DeleteConfirmationDialogProps } from "./types";

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  templateName = "",
  loading = false,
}) => {
  return (
    <Modal
      open={isOpen}
      title={
        <Space>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            style={{ color: "#ff4d4f" }}
          />
          <span>Delete Email Template</span>
        </Space>
      }
      onCancel={onClose}
      footer={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="primary"
            danger
            onClick={onConfirm}
            loading={loading}
            icon={<FontAwesomeIcon icon={faTrash} />}
          >
            Delete
          </Button>
        </Space>
      }
    >
      <p>
        Are you sure you want to delete the template "{templateName}"? This
        action cannot be undone.
      </p>
    </Modal>
  );
};

export default DeleteConfirmationDialog;
